import { LinkButton } from './Button';
import { ArrowRight } from 'lucide-react';

const CallToActionSection = () => {
  return (
    <section className="bg-slate-50">
      <div className="max-w-4xl mx-auto py-16 px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
          <span className="block">Unlock Your Next Investment Opportunity</span>
        </h2>
        <p className="mt-4 text-lg leading-6 text-gray-600">
          Access exclusive private market deals and build your alternative investment portfolio alongside a community of 1,500+ sophisticated investors.
        </p>
        <div className="mt-8">
          <LinkButton 
            to="/investments"
            variant="solid"
            size="lg"
            className="group"
          >
            <span>Explore Investments</span>
            <ArrowRight className="w-5 h-5 ml-2 transition-transform duration-300 group-hover:translate-x-1" />
          </LinkButton>
        </div>
      </div>
    </section>
  );
};

export default CallToActionSection;
